import React from 'react';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import ReactTable from 'Common/ReactTableWrapper';
import { DatePickerCustomButton } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CheckboxField, DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ON_HAND_REPORT_FIFO_FORM_NAME } from 'Common/FormEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { OnHandReportFifoEnum } from 'Common/FieldEnum';
import { getInventoryValue } from 'Common/FormHelper';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';

import { printOptions } from '../helper/onHand';

const FIFOReportComponent = props => {
  const {
    handleCollapsePanelClick,
    activeIndexes,
    clearFilters,
    columns,
    onChangeOfToDT,
    onChangeOfFromDT,
    setPrintOption,
    onSaveGridPreferenceClick,
    onHandFifoItems,
    loadingOnHandFifoItems,
    handleSubmit,
    printOptionsValue,
    disableFromToDates,
    gridPreferenceLoading,
    gridPreferenceSubmitting,
    onChangeOfShowAllOption,
    fromDateMax,
    toDateMin,
  } = props;

  const loading =
    loadingOnHandFifoItems || gridPreferenceLoading || gridPreferenceSubmitting;
  return (
    <Form onSubmit={handleSubmit}>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(0) !== -1}
          index={0}
          onClick={handleCollapsePanelClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>

        <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
          <Grid className="grid-spacing">
            <Grid.Row columns={2}>
              <Grid.Column>
                <div style={{ paddingTop: 25 }}>
                  <Header as="h4">Transaction Date Range</Header>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={4}>
              <Grid.Column width={4}>
                <Field
                  component={DatePickerField}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  label={'From:'}
                  name={OnHandReportFifoEnum.FromDt}
                  onChange={onChangeOfFromDT}
                  type={'text'}
                  maxDate={fromDateMax}
                  customInput={
                    <DatePickerCustomButton isDisabled={disableFromToDates} />
                  }
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  component={DatePickerField}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  label={'To:'}
                  name={OnHandReportFifoEnum.ToDt}
                  onChange={onChangeOfToDT}
                  type={'text'}
                  minDate={toDateMin}
                  customInput={
                    <DatePickerCustomButton isDisabled={disableFromToDates} />
                  }
                  dropdownMode="select"
                />
              </Grid.Column>
              <Grid.Column
                width={4}
                floated={'right'}
                textAlign={'right'}
                verticalAlign={'middle'}
                style={{
                  marginTop: 28,
                }}
              >
                <Field
                  component={CheckboxField}
                  toggle
                  label={'Show All Dates'}
                  name={OnHandReportFifoEnum.ShowAllDates}
                  type={'checkbox'}
                  onChange={onChangeOfShowAllOption}
                />
              </Grid.Column>
              <Grid.Column
                floated={'right'}
                textAlign={'right'}
                width={4}
                verticalAlign={'middle'}
                style={{
                  marginTop: 28,
                }}
              >
                <Button
                  content="Clear Filters"
                  onClick={clearFilters}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>

        <Accordion.Title
          active={activeIndexes.indexOf(1) !== -1}
          index={1}
          onClick={handleCollapsePanelClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Print</span>
        </Accordion.Title>

        <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
          <Grid className="tight">
            <Grid.Row columns={3}>
              <Grid.Column width={12}>
                <ReduxFormButtonGroup
                  options={printOptions}
                  value={printOptionsValue}
                  formName={ON_HAND_REPORT_FIFO_FORM_NAME}
                  fieldName={OnHandReportFifoEnum.PrintOptions}
                  onChange={setPrintOption}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>

      <Divider horizontal />

      <Grid>
        <Grid.Row>
          <Grid.Column floated={'right'} textAlign={'right'}>
            <Header as="h4" className={'text-orange'}>
              Inventory Value $ {getInventoryValue(onHandFifoItems)}
            </Header>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={1} className={'remove-spacing'}>
          <Grid.Column>
            <ReactTable
              defaultPageSize={20}
              showPageSizeOptions={true}
              minRows={0}
              loading={loading}
              loadingText={loading ? 'Loading...' : ''}
              noDataText={loading ? '' : 'No items found!'}
              data={onHandFifoItems}
              resizable={false}
              className="-striped -highlight"
              columns={columns}
              draggableColumns={true}
              showHideColumn={true}
              savePreference={onSaveGridPreferenceClick}
              menu={'hasCogs'}
              saveState={{
                tableName: TableNamesEnum.ON_HAND_REPORT_FIFO_TABLE,
              }}
              gridName={GridEnum.INV_OnHandReport_FIFO_View}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

FIFOReportComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  onHandFifoItems: PropTypes.array.isRequired,
  handleCollapsePanelClick: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  onChangeOfFromDT: PropTypes.func,
  setPrintOption: PropTypes.func,
  handleSubmit: PropTypes.func,
  onChangeOfShowAllOption: PropTypes.func,
  clearFilters: PropTypes.func,
  onSaveGridPreferenceClick: PropTypes.func,
  activeIndexes: PropTypes.array,
  printOptionsValue: PropTypes.number,
  loadingOnHandFifoItems: PropTypes.bool,
  disableFromToDates: PropTypes.bool,
  gridPreferenceLoading: PropTypes.bool,
  gridPreferenceSubmitting: PropTypes.bool,
  fromDateMax: PropTypes.object,
  toDateMin: PropTypes.object,
};

FIFOReportComponent.defaultProps = {
  onChangeOfToDT: () => {},
  onChangeOfFromDT: () => {},
  setPrintOption: () => {},
  handleSubmit: () => {},
  onChangeOfShowAllOption: () => {},
  clearFilters: () => {},
  onSaveGridPreferenceClick: () => {},
  activeIndexes: 0,
  printOptionsValue: 0,
  loadingOnHandFifoItems: false,
  disableFromToDates: false,
  gridPreferenceLoading: false,
  gridPreferenceSubmitting: false,
  fromDateMax: null,
  toDateMin: null,
};


export default FIFOReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/components/FIFOReport.js